import { render, staticRenderFns } from "./Screen4-2.vue?vue&type=template&id=6b8e098c&lang=html&"
import script from "./Screen4-2.vue?vue&type=script&lang=js&"
export * from "./Screen4-2.vue?vue&type=script&lang=js&"
import style0 from "./Screen4-2.vue?vue&type=style&index=0&id=6b8e098c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports